import { distributionAccountGetters } from "./accounts/getters";
import { distributionOrderGetters } from "./orders/getters";
import { importsGetters } from "./imports/getters";
import { distributionSupplierGetters } from "./suppliers/getters";
import { distributionStatementsGetters } from "./statement/getters";
import { shopsDistributionGetters } from "./shops/getters";
import { shop_groupsDistributionGetters } from "./shop_groups/getters";
import { DistributionModulePluginStore } from "./plugin-store";
import { distributionSupplierOrderGetters } from "./supplier_orders/getters";
import { distributionReleaseReportGetters } from "./release_report/getters";
export const getters = {
  ...importsGetters,
  ...distributionAccountGetters,
  ...distributionOrderGetters,
  ...distributionSupplierGetters,
  ...distributionStatementsGetters,
  ...shopsDistributionGetters,
  ...shop_groupsDistributionGetters,
  ...distributionSupplierOrderGetters,
  ...distributionReleaseReportGetters,
  ...DistributionModulePluginStore.getters,
};
